var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 24.1378L18.767 17.5298C20.355 15.6234 21.1468 13.1783 20.9779 10.703C20.8089 8.22764 19.6921 5.91276 17.8599 4.23987C16.0276 2.56698 13.6209 1.66488 11.1405 1.72124C8.66007 1.7776 6.29685 2.78808 4.54246 4.54246C2.78808 6.29685 1.7776 8.66007 1.72124 11.1405C1.66488 13.6209 2.56698 16.0276 4.23987 17.8599C5.91276 19.6921 8.22764 20.8089 10.703 20.9779C13.1783 21.1468 15.6234 20.355 17.5298 18.767L24.1378 25.375L25.375 24.1378ZM3.50004 11.375C3.50004 9.81751 3.9619 8.29496 4.82722 6.99992C5.69253 5.70489 6.92244 4.69553 8.36141 4.09949C9.80038 3.50345 11.3838 3.3475 12.9114 3.65136C14.439 3.95521 15.8422 4.70524 16.9435 5.80657C18.0448 6.90791 18.7949 8.3111 19.0987 9.8387C19.4026 11.3663 19.2466 12.9497 18.6506 14.3887C18.0546 15.8276 17.0452 17.0575 15.7502 17.9229C14.4551 18.7882 12.9326 19.25 11.375 19.25C9.28717 19.2477 7.28548 18.4173 5.80913 16.9409C4.33279 15.4646 3.50236 13.4629 3.50004 11.375Z",
    fill: "#666EB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.3f5f8f8f56143bae298727ab3fe1a10a.svg";
export { ForwardRef as ReactComponent };